(() => {
  if (customElements.get('bb-signature-header')) return;
  const navigationKey = 'broadbay-school-navigation-v1';
  const normalize = value => String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  const path = value => { try { return new URL(value, document.baseURI).pathname.replace(/\/$/, ''); } catch { return ''; } };
  const excluded = new Set(['illinois-illini', 'iowa-hawkeyes', 'iowa-state', 'missouri-tigers', 'southern-miss', 'northern-iowa-panthers']);
  const tagMap = {"alabama-crimson-tide": "Alabama", "arkansas-razorbacks": "Arkansas Razorbacks", "arizona-state": "Arizona State", "arizona-wildcats": "Arizona Wildcats", "auburn-tigers": "Auburn Tigers", "baylor-bears": "Baylor", "boise-state-broncos": "Boise State Broncos", "charlotte-49ers": "Charlotte 49ers", "clemson-tigers": "Clemson Tigers", "east-carolina": "ECU Pirates", "eastern-kentucky": "Eastern Kentucky", "florida-gators": "Florida Gators", "florida-state": "Florida State", "georgia-bulldogs": "Georgia Bulldogs", "george-mason": "george mason Patriots", "georgia-southern": "Georgia Southern", "georgia-tech": "Georgia Tech", "houston-cougars": "Houston Cougars", "illinois-illini": "Illinois", "indiana-university": "Indiana University", "iowa-hawkeyes": "Iowa Hawkeyes", "iowa-state": "Iowa State University", "james-madison": "JMU", "kansas-jayhawks": "Kansas Jayhawks", "kansas-state": "Kansas State", "kentucky-wildcats": "Kentucky Wildcats", "louisville-cardinals": "Louisville Cardinals", "lsu-tigers": "LSU Tigers", "marshall-university": "Marshall", "miami-university": "Miami University", "michigan-state-spartans": "Michigan State", "middle-tennessee": "Middle Tennessee", "mississippi-state": "Mississippi State", "missouri-state-bears": "Missouri State", "missouri-tigers": "Mizzou", "naval-academy-midshipmen": "Naval Academy", "nc-state": "NC State", "nebraska-huskers": "Nebraska Huskers", "northern-iowa-panthers": "Northern Iowa", "northwestern-wildcats": "Northwestern", "ohio-state-buckeyes": "Ohio State", "ohio-university-bobcats": "Ohio University", "oklahoma-state-cowboys": "Oklahoma State", "old-dominion-monarchs": "ODU", "ole-miss": "Ole Miss", "oregon-state-beavers": "Oregon State", "purdue-university": "Purdue", "rutgers-university": "Rutgers", "south-carolina-gamecocks": "University of South Carolina", "southern-miss": "Southern Miss", "tcu-horned-frogs": "TCU", "tennessee-vols": "Tennessee", "texas-a-m": "TAMU", "texas-tech": "Texas Tech Red Raiders", "utep-miners": "UTEP", "virginia-cavaliers": "Virginia Cavaliers", "virginia-tech": "Virginia Tech", "washington-state-cougars": "Washington State", "west-virginia-mountaineers": "West Virginia", "ucf": "UCF"};
  class SignatureHeader extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.schoolMenu = this.querySelector('.bbh-school-menu');
      this.disclosures = [...this.querySelectorAll('[data-bb-nav-details]')];
      this.context = JSON.parse(this.querySelector('[data-bbh-context-data]').textContent);
      this.schools = [...this.schoolMenu.querySelectorAll('[data-bb-team] a')].map(link => {
        const url = path(link.href);
        const handle = url.split('/').pop();
        return { url, handle, name: link.querySelector('.bb-school-name').textContent.trim(), logo: link.querySelector('img')?.getAttribute('src') || '', tag: tagMap[handle] || '', link };
      });
      this.schoolMenu.querySelector('summary').addEventListener('click', () => this.setBrowseIntent(this.currentBrowseIntent()), { signal });
      this.querySelectorAll('[data-bbh-browse]').forEach(link => link.addEventListener('click', event => {
        event.preventDefault();
        this.openSchools(link.dataset.bbhBrowse);
      }, { signal }));
      this.querySelector('[data-bbh-my-school]').addEventListener('click', event => {
        if (this.selectedSchool) return;
        event.preventDefault();
        this.openSchools();
      }, { signal });
      this.querySelectorAll('[data-bbh-choose]').forEach(link => link.addEventListener('click', event => {
        event.preventDefault();
        this.openSchools(this.currentBrowseIntent());
      }, { signal }));
      this.querySelector('[data-bbh-cart]').addEventListener('click', event => {
        const drawer = document.querySelector('#mini-cart');
        if (typeof drawer?.open !== 'function') return;
        event.preventDefault();
        this.disclosures.forEach(menu => { menu.open = false; });
        this.querySelector('bb-site-search')?.close();
        drawer.open();
      }, { signal });
      const drawer = document.querySelector('#mini-cart');
      if (drawer) {
        const syncDrawer = () => {
          const isOpen = drawer.classList.contains('open');
          if (!isOpen && drawer.contains(document.activeElement)) this.querySelector('[data-bbh-cart]').focus({ preventScroll: true });
          drawer.setAttribute('aria-hidden', String(!isOpen));
          drawer.setAttribute('role', 'dialog');
          drawer.setAttribute('aria-label', this.querySelector('[data-bbh-cart]').getAttribute('aria-label'));
          drawer.setAttribute('aria-modal', String(isOpen));
          drawer.querySelector('.mini-cart__sidebar')?.setAttribute('aria-hidden', String(!isOpen));
          drawer.inert = !isOpen;
          if (isOpen && !drawer.contains(document.activeElement)) drawer.querySelector('#cart-close')?.focus({ preventScroll: true });
        };
        this.drawerObserver = new MutationObserver(syncDrawer);
        this.drawerObserver.observe(drawer, { attributes: true, attributeFilter: ['class'] });
        syncDrawer();
      }
      document.addEventListener('click', event => {
        const link = event.target.closest('a[href]');
        if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.target === '_blank' || link.hasAttribute('download')) return;
        const destination = new URL(link.href, document.baseURI);
        if (destination.origin !== location.origin || destination.pathname + destination.search === location.pathname + location.search) return;
        const school = this.schools.find(item => item.url === path(link.href));
        if (school) this.selectSchool(school);
        if (this.selectedSchool) {
          try {
            sessionStorage.setItem(navigationKey, JSON.stringify({ school: this.selectedSchool.url, target: destination.pathname + destination.search, time: Date.now() }));
          } catch {}
        }
      }, { signal });
      document.addEventListener('focusin', event => {
        this.disclosures.forEach(menu => {
          if (menu.open && !menu.contains(event.target) && !event.target.closest('[data-bbh-choose], [data-bbh-browse]')) menu.open = false;
        });
      }, { signal });
      this.disclosures.forEach(menu => menu.addEventListener('toggle', () => {
        menu.querySelector('summary').setAttribute('aria-expanded', String(menu.open));
        this.syncBrowseTriggers();
      }, { signal }));
      window.addEventListener('pageshow', event => { if (event.persisted) this.restoreSchool(true); }, { signal });
      document.addEventListener('bb:guide-updated', () => this.setBrowseIntent(this.currentBrowseIntent()), { signal });
      this.restoreSchool();
      this.initializeScrollHeader(signal);
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.drawerObserver?.disconnect();
      this.headerObserver?.disconnect();
      cancelAnimationFrame(this.scrollFrame);
      cancelAnimationFrame(this.resizeFrame);
      this.headerWrap?.classList.remove('bbh-scroll-ready');
      this.headerWrap?.style.removeProperty('--bbh-expanded-height');
      this.abort = null;
    }
    initializeScrollHeader(signal) {
      this.headerWrap = this.closest('#nav-wrapper');
      if (!this.headerWrap) return;
      this.lastScrollY = Math.max(0, window.scrollY);
      this.scrollTravel = 0;
      this.measureExpandedHeader();
      this.headerWrap.classList.add('bbh-scroll-ready');
      this.headerObserver = new ResizeObserver(() => {
        if (!this.classList.contains('bbh-is-compact')) this.measureExpandedHeader();
      });
      this.headerObserver.observe(this);
      window.addEventListener('scroll', () => {
        if (this.scrollFrame) return;
        this.scrollFrame = requestAnimationFrame(() => {
          this.scrollFrame = 0;
          this.updateScrollHeader();
        });
      }, { signal, passive: true });
      window.addEventListener('resize', () => {
        cancelAnimationFrame(this.resizeFrame);
        this.resizeFrame = requestAnimationFrame(() => this.measureExpandedHeader());
      }, { signal, passive: true });
      const restore = () => {
        this.measureExpandedHeader();
        this.lastScrollY = Math.max(0, window.scrollY);
        this.scrollTravel = 0;
        this.setCompactHeader(this.lastScrollY > Math.min(this.expandedHeight, 120) + 24);
      };
      window.addEventListener('pageshow', restore, { signal });
      this.querySelector('[data-bbh-expand-search]')?.addEventListener('click', () => {
        this.setCompactHeader(false);
        this.querySelector('.bbh-search [data-bb-search-input]')?.focus({ preventScroll: true });
      }, { signal });
      restore();
    }
    measureExpandedHeader() {
      const compact = this.classList.contains('bbh-is-compact');
      if (compact) this.classList.remove('bbh-is-compact');
      const height = Math.ceil(this.getBoundingClientRect().height);
      if (height && height !== this.expandedHeight) {
        this.expandedHeight = height;
        this.headerWrap.style.setProperty('--bbh-expanded-height', `${height}px`);
      }
      if (compact) this.classList.add('bbh-is-compact');
    }
    setCompactHeader(compact) {
      this.classList.toggle('bbh-is-compact', compact);
      this.querySelector('[data-bbh-expand-search]')?.setAttribute('aria-expanded', String(!compact));
    }
    updateScrollHeader() {
      const maxScroll = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
      const y = Math.min(maxScroll, Math.max(0, window.scrollY));
      const delta = y - this.lastScrollY;
      this.lastScrollY = y;
      if (y <= 24) {
        this.scrollTravel = 0;
        this.setCompactHeader(false);
        return;
      }
      const active = document.activeElement;
      const interacting = this.disclosures.some(menu => menu.open) || this.querySelector('bb-site-search[open]') || (this.contains(active) && (active.matches('input, textarea, select, [contenteditable]') || (delta > 0 && active.matches(':focus-visible'))));
      if (interacting) {
        this.scrollTravel = 0;
        return;
      }
      if (!delta) return;
      this.scrollTravel = Math.sign(delta) === Math.sign(this.scrollTravel) ? this.scrollTravel + delta : delta;
      if (this.scrollTravel <= -12) this.setCompactHeader(false);
      else if (this.scrollTravel >= 24 && y > Math.min(this.expandedHeight, 120) + 24) this.setCompactHeader(true);
    }
    currentBrowseIntent() {
      if (this.context.pageType !== 'collection') return undefined;
      const params = new URLSearchParams(location.search);
      const cap = params.get('filter.v.price.lte');
      if (cap && Number(cap) >= 0 && Number(cap) <= 49.99) return 'under_50';
      if (params.get('sort_by') === 'best-selling') return 'best_sellers';
      return undefined;
    }
    browseUrl(school, intent) {
      const query = this.context.browse?.[intent]?.query;
      return school.url + (query ? `?${query}` : '');
    }
    setBrowseIntent(intent) {
      this.browseIntent = intent;
      const browse = this.context.browse?.[intent];
      this.querySelector('[data-bbh-school-heading]').textContent = browse?.heading || this.context.schoolHeading;
      this.querySelector('[data-bbh-school-intro]').textContent = browse?.intro || this.context.schoolIntro;
      this.schools.forEach(school => { school.link.href = this.browseUrl(school, intent); });
      this.syncBrowseTriggers();
    }
    syncBrowseTriggers() {
      this.querySelectorAll('[data-bbh-browse]').forEach(button => {
        button.setAttribute('aria-expanded', String(this.schoolMenu.open && this.browseIntent === button.dataset.bbhBrowse));
      });
    }
    openSchools(intent) {
      this.setBrowseIntent(intent);
      this.disclosures.forEach(menu => { menu.open = menu === this.schoolMenu; });
      this.querySelector('bb-site-search')?.close();
      const input = this.schoolMenu.querySelector('[data-bb-team-search]');
      input.value = '';
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.focus({ preventScroll: true });
      if (this.getBoundingClientRect().bottom < 0) this.scrollIntoView({ block: 'start' });
    }
    restoreSchool(fromCache = false) {
      const context = this.context;
      let selected = this.schools.find(school => school.handle === this.dataset.bbhSchoolContext);
      const hasSchoolContext = Boolean(selected) && ['product', 'collection'].includes(context.pageType);
      try { localStorage.removeItem('broadbay-selected-school-v1'); } catch {}
      try {
        const pending = JSON.parse(sessionStorage.getItem(navigationKey));
        sessionStorage.removeItem(navigationKey);
        const internalArrival = document.referrer && new URL(document.referrer).origin === location.origin;
        if (!selected && !fromCache && internalArrival && pending?.target === location.pathname + location.search && Date.now() - pending.time < 30000) {
          selected = this.schools.find(school => school.url === pending.school);
        }
      } catch {}
      if (selected) this.selectSchool(selected, hasSchoolContext);
      else {
        this.selectedSchool = undefined;
        this.querySelector('[data-bbh-school-label]').textContent = context.chooseSchool;
        this.querySelector('[data-bbh-my-school]').href = this.schoolMenu.querySelector('.bbh-panel-foot a').href;
        this.querySelector('[data-bbh-context]').hidden = true;
        this.schools.forEach(school => school.link.removeAttribute('data-selected'));
      }
    }
    selectSchool(school, showContext = false) {
      this.selectedSchool = school;
      this.querySelector('[data-bbh-my-school]').href = school.url;
      this.querySelector('[data-bbh-school-label]').textContent = school.name;
      const link = this.querySelector('[data-bbh-current]');
      link.href = school.url;
      this.querySelector('[data-bbh-current-name]').textContent = school.name;
      const logo = this.querySelector('[data-bbh-current-logo]');
      logo.hidden = !school.logo;
      if (school.logo) logo.src = school.logo;
      const categories = this.querySelector('[data-bbh-categories]');
      const fragment = document.createDocumentFragment();
      const addLink = (url, title) => {
        const item = document.createElement('a');
        item.href = url;
        item.textContent = title;
        if (path(location.pathname) === path(url)) item.setAttribute('aria-current', 'page');
        fragment.append(item);
      };
      addLink(school.url, this.context.allLabel);
      if (school.tag && !excluded.has(school.handle)) {
        this.context.categories.forEach(category => {
          const tag = (category.tags || []).find(item => normalize(item) === normalize(school.tag));
          if (!category.url || !tag) return;
          const handle = normalize(tag).replace(/ /g, '-');
          addLink(`${category.url}/${handle}`, category.title);
        });
      }
      categories.replaceChildren(fragment);
      this.querySelector('[data-bbh-context]').hidden = !showContext;
      this.schools.forEach(item => item.link.toggleAttribute('data-selected', item === school));
    }
  }
  customElements.define('bb-signature-header', SignatureHeader);
})();

